import React from 'react'
import { useEffect } from 'react';
import DocSearchHeader from './components/DocSearchHeader'
import DocSearchResult from './components/DocSearchResult'
import DocSearch from './components/DocSearch'
import { searchRecords, restoreSearchState} from './components/DocSCFunctions';
import useRowSelector from "../../../library/hooks/selector/useRowSelector";
import SarasMsg from '../../../library/notifications/SarasMsg';
import searchViewMap from './Index';
import tourSteps from './TourSteps';
import * as formJS from '../docAutomation/formFunctions';
import * as uiJS from '../../../helper/uiFunctions';
import { UiGroupContent } from "../../../library/layout/Index";
import SarasTour from '../../../library/navigate/SarasTour';
import useDynamicGroup from './components/useDynamicGroup';
import { useStickyTop } from '../../../library/hooks/appearance/useStickyTop';

//initialConfig need to be sent to the server during restore process
//this is to integrate the search screen with other document. eg: show the sales of a customer in the customer screen
const DocSearchContainer = (props) => {
  const { enableSelect, enableDefaultActions, onSelectedRowsChange, docTypeId, initialConfig,
    disableHeaderAndSearch, parentScrollRef, isEmbedded = false, subViewID, isRefresh, deviceInfo } = props;

  //store the header view data in the state
  const [viewData, setViewData] = React.useState({});
  const [birdEyeViewData, setBirdEyeViewData] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [currentFavKey, setCurrentFavKey] = React.useState(0);
  const [currentCriteriaValue, setCurrentCriteriaValue] = React.useState("");
  const [currentGroupKey, setCurrentGroupKey] = React.useState("");
  const [currentSortKey, setCurrentSortKey] = React.useState("");
  const [currentDynamicGroupKey, setCurrentDynamicGroupKey] = React.useState("");
  const [srFieldSearchRequest, setSRFieldSearchRequest] = React.useState({});
  const [srURLParams, setSRURLParams] = React.useState("");
  const [srURLParamsJson, setSRURLParamsJson] = React.useState({});
  const [documentTypeId, setDocumentTypeId] = React.useState('');
  const [searchStateKey, setSearchStateKey] = React.useState('');
  const [userColumns, setUserColumns] = React.useState({key: "", columns: null});
  const [searchNotifications, setSearchNotifications] = React.useState(null);
  const [recalculateParameters, setRecalculateParameters] = React.useState(1);
  const [pendingGroupRefresh, setPendingGroupRefresh] = React.useState({
    pending: false,
    nodePath: null
  });

  const stickyElement = useStickyTop(isEmbedded ? 0 : 35, parentScrollRef);

  // console.log("sticky element", stickyElement);

  const rowSelector = useRowSelector(
    (enableSelect || formJS.getValueFromKey(viewData, "childViews.resultView.dataList.enableSelect", "0")),
    onSelectedRowsChange
  );
  
  const onSearchSuccess = (response) => {
    setViewData(response.data.mainViewData);
    //reset the shortcut search request after a successful search
    setSRFieldSearchRequest({});

    
    //set the search state key received from the search result
    const userColumnsJS = formJS.getValueFromKey(response.data.mainViewData, "childViews.resultView.headerRows.columnSelectorRow.rowValues", null);
    const userPreferenceKey = formJS.getValueFromKey(response.data.mainViewData, "childViews.resultView.headerRows.columnSelectorRow.dataList.preferenceKey", "");
    const stateKey = formJS.getValueFromKey(response.data.mainViewData, "childViews.resultView.dataList.searchStateKey", "");
    const criteria = formJS.getValueFromKey(response.data.mainViewData, "childViews.resultView.dataList.cmnCriteriaValue", "");
    const groupKey = formJS.getValueFromKey(response.data.mainViewData, "childViews.groupView.dataList.groupKey", "");
    const sortKey = formJS.getValueFromKey(response.data.mainViewData, "childViews.sortView.dataList.sortKey", "");
    // const dynamicGroupChoiceDataState = formJS.getValueFromKey(response.data.mainViewData, "childViews.dynamicGroupChoiceView", "");
    const dynamicGroupKey = formJS.getValueFromKey(response.data.mainViewData, "childViews.dynamicGroupView.dataList.dynamicGroupKey", "");
    
    // console.log("search user columns", userColumnsJS);

    setUserColumns({key: userPreferenceKey, columns: userColumnsJS});
    setSearchStateKey(stateKey);
    setCurrentGroupKey(groupKey);
    setCurrentSortKey(sortKey);
    setCurrentCriteriaValue(criteria);
    
    setCurrentDynamicGroupKey(dynamicGroupKey);

    setSearchNotifications(null);

    if(response.data.isError === 1){
      //display the error message
      setSearchNotifications({msgType: response.data.isError, msg:response.data.msg, messageList:response.data.messageList || {}});
    }

    //reset page tracker
    rowSelector.onPageChange();
    setRecalculateParameters(1);
  }

  const onBirdEyeViewSuccess = (response) => {
    // console.log("bird eye search response", response);
    setBirdEyeViewData(response.data.mainViewData);
  }

  //pass undefined to the parameters that need to pick automatically from the last searched value
  const triggerSearch = (page, favKey, criteriaValue, groupKey, sortKey, dynamicGroupKey, reload, nodePath) => {
    if(favKey === undefined) favKey = currentFavKey;
    if(criteriaValue === undefined) criteriaValue = currentCriteriaValue;
    if(groupKey === undefined) groupKey = currentGroupKey;
    if(page === undefined) page = currentPage;
    if(sortKey === undefined) sortKey = currentSortKey;
    if(dynamicGroupKey === undefined) dynamicGroupKey = currentDynamicGroupKey;

    // console.log("trigger search dynamic group key", dynamicGroupKey);

    if(uiJS.compareNumber(reload, 1)){
      //reset the bird eye view data after every reload of the data, 
      //this will trigger the reload for bird eye view data from server for the new set of criteria
      setBirdEyeViewData(null);

      setPendingGroupRefresh({
        pending: true,
        nodePath: nodePath
      });
    }
    
    // console.log("criteria changed 2", dynamicGroupKey, criteriaValue, " node path ", nodePath);

    setSearchNotifications({msgType:2, msg:"Searching...", messageList:{}});

    searchRecords("detailView", page, documentTypeId, srURLParamsJson, favKey, criteriaValue, 
      groupKey, sortKey, {dynamicGroupKey: dynamicGroupKey, nodePath: ""}, reload, 
      subViewID, searchStateKey, onSearchSuccess);
  }

  const onBirdEyeView = () => {
    const favKey = currentFavKey;
    const criteriaValue = currentCriteriaValue;
    const groupKey = currentGroupKey;
    const sortKey = currentSortKey;
    const dynamicGroupKey = currentDynamicGroupKey;

    //if birdEyeViewData is missing it means the summary is not available or the criteria have changed
    //hence trigger reload

    if(!birdEyeViewData){
      searchRecords("birdEyeView", 1, documentTypeId, srURLParamsJson, favKey, criteriaValue, 
        groupKey, sortKey, {dynamicGroupKey: dynamicGroupKey, nodePath: ""}, 1, 
        subViewID, searchStateKey, onBirdEyeViewSuccess);
    }
  }

  const onPageChange = (page) => {
    // console.log("page changed", page);
    setCurrentPage(page);

    triggerSearch(page);
  }

  const onSearchByCriteria = (reload, criteriaValue) => {
    // console.log("selected criteria",reload, criteriaValue);
    //reset fav key search
    setCurrentFavKey(0);

    setCurrentCriteriaValue(criteriaValue);
    
    // console.log("criteria changed 1", currentDynamicGroupKey, criteriaValue);

    triggerSearch(1, 0, criteriaValue, undefined, undefined, undefined, 1);
  }

  const onChangeDynamicGroup = (nodePath, dynamicGroupKey) => {
    let groupKey = currentDynamicGroupKey;
    // console.log("search by group", groupKey);
    setCurrentDynamicGroupKey(dynamicGroupKey);

    if(dynamicGroupKey) {
      // console.log("dynamic group key search triggered with ", dynamicGroupKey);
        onDynamicGroupView(nodePath, dynamicGroupKey, false);
    }

    setRecalculateParameters(1);

    //trigger search results to reset the result set after the group key changed
    if(groupKey !== dynamicGroupKey && dynamicGroupKey === "") {
      // console.log("criteria changed 3", dynamicGroupKey, currentCriteriaValue);
      // console.log("data search triggered with ", dynamicGroupKey);
      triggerSearch(1, 0, undefined, undefined, undefined, null, 1);
    }
  }

  const onRefreshDynamicGroup = (nodePath, dynamicGroupKey) => {
    if(dynamicGroupKey) {
      // console.log("dynamic group key search triggered with ", dynamicGroupKey);
        onDynamicGroupView(nodePath, dynamicGroupKey, true);
    }
  }

  const onSearchByDynamicGroup = (key, nodePath, inRefreshLoop) => {
    // console.log("criteria changed 4", currentDynamicGroupKey, currentCriteriaValue, " key", key);
    //skip reload if the key has not changed
    if(currentDynamicGroupKey === key) return;

    // console.log("dynamicgroup search trigger", key);
    setCurrentDynamicGroupKey(key);

    triggerSearch(1, undefined, undefined, undefined, undefined, key, 1, {nodePath: nodePath, inRefreshLoop: inRefreshLoop});
  }

  const dynamicGroupManager = useDynamicGroup({
    dynamicGroupData: (viewData && viewData.childViews && viewData.childViews.dynamicGroupView && viewData.childViews.dynamicGroupView.viewRows) || {},
    currentKey: currentDynamicGroupKey,
    // dynamicGroupChoiceData: dynamicGroupChoiceData,
    onGroupSelected: onChangeDynamicGroup,
    onGroupRefresh: onRefreshDynamicGroup,
    onSearchByDynamicGroup: onSearchByDynamicGroup
  });

  const onPendingRefreshGroupView = () => {
    if (!pendingGroupRefresh.pending) return;

    // refresh dynamic group data
    if(dynamicGroupManager && typeof dynamicGroupManager.refreshGroupData === "function") {
      if(!pendingGroupRefresh.nodePath) dynamicGroupManager.refreshGroupData();
      else if(pendingGroupRefresh.nodePath.inRefreshLoop === 0) dynamicGroupManager.refreshGroupData(pendingGroupRefresh.nodePath.nodePath);
    }

    setPendingGroupRefresh({ pending: false, nodePath: null});
  }

  useEffect(onPendingRefreshGroupView, [pendingGroupRefresh, dynamicGroupManager]);

  const onDynamicGroupView = (nodePath, dynamicGroupKey, isRefresh) => {
    const favKey = currentFavKey;
    const criteriaValue = currentCriteriaValue;
    const groupKey = currentGroupKey;
    const sortKey = currentSortKey;
    if (!dynamicGroupKey) dynamicGroupKey = currentDynamicGroupKey;

    searchRecords("dynamicGroupChoiceView", 1, documentTypeId, srURLParamsJson, favKey, criteriaValue, 
      groupKey, sortKey, {dynamicGroupKey: dynamicGroupKey, nodePath: nodePath}, 1, 
      subViewID, searchStateKey, isRefresh ? onDynamicGroupRefreshSuccess : onDynamicGroupViewSuccess);
  }

  const onDynamicGroupRefreshSuccess = (response, requestObject) => {
    // console.log("bird eye search response", response);
    dynamicGroupManager.onGroupChoiceDataRefresh(requestObject.dataList.dynamicGroupNodePath, response.data.mainViewData);
  }

  const onDynamicGroupViewSuccess = (response, requestObject) => {
    // console.log("bird eye search response", response);
    dynamicGroupManager.onGroupChoiceDataReceived(requestObject.dataList.dynamicGroupNodePath, response.data.mainViewData);
  }

  const onSearchByGroup = (groupKey) => {
    // console.log("search by group", groupKey);
    setCurrentGroupKey(groupKey);
    setCurrentDynamicGroupKey("");

    dynamicGroupManager.onClearGroupSelection(true);

    if(groupKey) triggerSearch(1, undefined, undefined, groupKey, undefined, null, 1);
  }

  const onChangeSort = (sortKey) => {
    // console.log("search by group", groupKey);
    setCurrentSortKey(sortKey);

    if(sortKey) triggerSearch(1, undefined, undefined, undefined, sortKey, undefined, 1);
  }

  const onSearchEditorRequest = (targetRef, fieldKey) => {
    // console.log("search editor requested", targetRef, fieldKey);
    setSRFieldSearchRequest({targetRef, fieldKey});
    // console.log("search editor requested", {anchorRef, fieldKey});
  }

  const initiateSearch = () => {
    let dtId = docTypeId || props.match.params.documentTypeId;
    let urlParams = "";

    if(props.match) {
      urlParams = props.match.params.documentId;
    }

    if(!viewData || !viewData.masterKeys 
      || !uiJS.compareNumber(viewData.masterKeys.dtId, dtId)
      || urlParams !== srURLParams
      || isRefresh)
    {
      setDocumentTypeId(dtId);
      setSRURLParams(urlParams);
      let urlParamsJson = uiJS.convertStrToKeyValue(urlParams);
      setSRURLParamsJson(urlParamsJson);

      setSearchNotifications({msgType:2, msg:"Searching...", messageList:{}});

      // console.log("doc search initiate search", initialConfig, currentGroupKey);

      //send first request to restore the last saved search state
      restoreSearchState(dtId, urlParamsJson, onSearchSuccess, subViewID, initialConfig);
    }
  };

  //trigger search if url changes or when data is received from the server
  useEffect(initiateSearch, [docTypeId, props.match, subViewID, initialConfig]);

  const reloadSearch = (clearSelection) => {
    if(uiJS.compareNumber(clearSelection, 1)){
      rowSelector.clearAllSelection();
    }

    triggerSearch(undefined, 0, undefined, undefined, undefined, undefined, 1);
  }

  const refreshSearch = () => {
      if(isRefresh){
        triggerSearch(undefined, 0, undefined, undefined, undefined, undefined, 1);
      }
  }

  useEffect(refreshSearch, [isRefresh]);
  
  //render only if there is search result and the search result document type id is matching with the type id of the url
  if(!viewData || !viewData.masterKeys || !uiJS.compareNumber(viewData.masterKeys.dtId, documentTypeId))
  {
    return (<SarasMsg notification={searchNotifications} />);
  }
  else
  {
    return (
      <>
        <SarasTour steps={tourSteps} tourKey={'docSearch'}/>
        <div 
          className="uiInvSearch phViewArea uiViewSections"
          >
          <SarasMsg notification={searchNotifications} />
          <DocSearchHeader viewMap={searchViewMap} viewData={viewData} enableDefault={enableDefaultActions!==false} 
            disableHeader={disableHeaderAndSearch} rowSelector={rowSelector} reloadSearch={reloadSearch}
            deviceInfo={deviceInfo}
          />
          <div 
            className={`uiInvSearchHeader uiStickyElement ${stickyElement.isScrolling ? "uiStickyHeaderScrolling" : ""}`}
            style={{ '--sticky-top': `${stickyElement.isScrolling ? stickyElement.stickyTop : 0}px` }} 
          >
            <DocSearch viewData={viewData} 
              shortcutSearchRequested={srFieldSearchRequest}
              onSearchByCriteria={onSearchByCriteria} disableSearch={disableHeaderAndSearch}
              defaultGroup = {currentGroupKey}
              deviceInfo={deviceInfo}
              defaultDynamicGroup = {currentDynamicGroupKey}
              onSearchByGroup={onSearchByGroup} 
              enableGroups={true} 
              enableSearch={true}
              birdEyeViewData={birdEyeViewData} 
              userColumns={userColumns}
              dynamicGroupManager={dynamicGroupManager}
              reloadSearch={reloadSearch}
              onBirdEyeView={onBirdEyeView}
              defaultSort = {currentSortKey}
              onChangeSort={onChangeSort}
              onPageChange={onPageChange}
              />
          </div>
          <UiGroupContent className="uiGroupContentSR">
            <div className="uiSearchResults" ref={stickyElement.ref}>
              <div className="detailcontents">
                <DocSearchResult viewData={viewData} onSearchRequest={onSearchEditorRequest} 
                  rowSelector={rowSelector} reloadSearch={reloadSearch} 
                  dynamicGroupManager={dynamicGroupManager}
                  deviceInfo={deviceInfo}
                  stickyTop={stickyElement.isScrolling ? stickyElement.stickyTop + (currentCriteriaValue || dynamicGroupManager.hasDynamicGroupSelection ? 65 : 35) : 0}
                  setRecalculateParameters={setRecalculateParameters} recalculateParameters={recalculateParameters}/>
              </div>
            </div>
          </UiGroupContent>
        </div>
      </>
    )
  }
}

export default DocSearchContainer;
